import React from 'react';

const cardStyle = (cardWidth) => ({
  minWidth: cardWidth,
  maxWidth: cardWidth
});

const CardLink = (props) => {
  return (
    <>
      <div>
        <a className='marketplace-card-hyperlink' href={props.path}>
          <div className='marketplace-card-link' style={cardStyle(props.cardWidth)}>
            <div className='marketplace-card-name'>Show more</div>
          </div>
        </a>
      </div>
    </>
  );
};

export default CardLink;
